import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Info({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M20.167 10.782322c0 1.22232-1.0006667 2.21232-2.2346667 2.21232s-2.2346666-.99-2.2346666-2.21232c0-1.22166 1.0006666-2.21232 2.2346666-2.21232 1.234 0 2.2346667.99066 2.2346667 2.21232zm-4.022 15.36678h3.5753333v-10.6194H16.145v10.6194zm1.7873333-24.8457C8.86566667 1.303402 1.507 8.587822 1.507 17.563822c0 8.976 7.35866667 16.26108 16.4253333 16.26108 9.0666667 0 16.4253334-7.28508 16.4253334-16.26108 0-8.976-7.3586667-16.26042-16.4253334-16.26042z" />
      </g>
    </svg>
  )
}

Info.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
